<ui-empty-state icon="shield-off" titleAs="h1" heading="No role set">
  <p uiEmptyStateBody>
    You have a seat in {{ partnerName() }}, but no role has been assigned to it yet — so there's
    nothing here you can open. Speak to your partner area owner to get one.
  </p>

  @if (ownerEmail(); as email) {
    <a ui-link-button leadIcon="mail" [href]="'mailto:' + email">Email {{ email }}</a>
  }

  @if (hasOtherPartners()) {
    <p uiEmptyStateBody="sm">
      Work in more than one partner area? Switch using the control at the bottom of the sidebar.
    </p>
  }
</ui-empty-state>
